// Attachments section inside TaskModal (and any stacked dropzone+list usage).
//
// State + upload/delete/preview logic lives in the shared useAttachments hook
// and the AttachmentList presentational pieces (see ./attachments/*). This
// component just wires them into the original stacked layout: header → drop-
// zone → list. The project-detail page splits the same hook across three cards.

import type { AttachmentMeta } from "@juuplan/shared";
import { useAttachments } from "./attachments/useAttachments";
import {
  AttachmentDropzone,
  AttachmentRows,
} from "./attachments/AttachmentList";

// Either taskId, projectId or personalTaskId — the hook dispatches gegen die
// passende API.
interface Props {
  taskId?: number;
  projectId?: number;
  personalTaskId?: number;
}

export function AttachmentsSection(props: Props): preact.JSX.Element {
  const att = useAttachments({
    taskId: props.taskId,
    projectId: props.projectId,
    personalTaskId: props.personalTaskId,
  });
  const { items, pending, loading } = att;

  return (
    <section>
      <h3 class="text-xs font-semibold uppercase tracking-wider text-[color:var(--color-on-surface-variant)] mb-2 flex items-center gap-2">
        Anhänge
        {att.totalCount > 0 && (
          <span class="text-label font-medium normal-case tracking-normal text-[color:var(--color-on-surface-variant)]">
            {att.totalCount}
          </span>
        )}
      </h3>

      <AttachmentDropzone hook={att} />

      {loading && items.length === 0 ? (
        <p class="mt-3 text-xs text-[color:var(--color-on-surface-variant)] italic">
          Lädt…
        </p>
      ) : items.length === 0 && pending.length === 0 ? (
        <p class="mt-3 text-xs text-[color:var(--color-on-surface-variant)] italic">
          Noch keine Anhänge.
        </p>
      ) : (
        <div class="mt-3">
          <AttachmentRows
            items={items as AttachmentMeta[]}
            pending={pending}
            onDelete={att.doDelete}
          />
        </div>
      )}
    </section>
  );
}
